// Okres w nagłówku filtrów: gotowe okresy jak menu „Data produkcji” w legacy albo własny zakres dat.
// Daty jako tekst RRRR-MM-DD, liczone w czasie lokalnym przeglądarki (Europe/Warsaw u użytkowników).

export type GotowyOkres = 'dzis' | 'wczoraj' | 'tydzien' | 'miesiac' | 'pop_miesiac' | 'rok'

/** Gotowy okres liczy się od nowa każdego dnia; własny zakres pamięta konkretne daty. */
export type Okres = { gotowy: GotowyOkres } | { od: string; do: string }

export const GOTOWE_OKRESY: GotowyOkres[] = ['dzis', 'wczoraj', 'tydzien', 'miesiac', 'pop_miesiac', 'rok']

export const ETYKIETY_OKRESOW: Record<GotowyOkres, string> = {
  dzis: 'Dzisiaj',
  wczoraj: 'Wczoraj',
  tydzien: 'Ten tydzień',
  miesiac: 'Ten miesiąc',
  pop_miesiac: 'Poprzedni miesiąc',
  rok: 'Aktualny rok',
}

export const ETYKIETA_WLASNEGO_ZAKRESU = 'Własny zakres'

export function dataTekst(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

const WZOR_DATY = /^(\d{4})-(\d{2})-(\d{2})$/

/** Poprawna data kalendarzowa RRRR-MM-DD (np. 2026-02-30 nie jest). */
export function poprawnaData(s: unknown): s is string {
  if (typeof s !== 'string') return false
  const m = WZOR_DATY.exec(s)
  if (!m) return false
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
  return dataTekst(d) === s
}

export function zakresOkresu(g: GotowyOkres, teraz: Date = new Date()): { od: string; do: string } {
  const r = teraz.getFullYear()
  const m = teraz.getMonth()
  const d = teraz.getDate()
  const dzien = (rr: number, mm: number, dd: number) => dataTekst(new Date(rr, mm, dd))
  switch (g) {
    case 'dzis':
      return { od: dzien(r, m, d), do: dzien(r, m, d) }
    case 'wczoraj':
      return { od: dzien(r, m, d - 1), do: dzien(r, m, d - 1) }
    case 'tydzien': {
      const odPoniedzialku = (teraz.getDay() + 6) % 7
      return { od: dzien(r, m, d - odPoniedzialku), do: dzien(r, m, d - odPoniedzialku + 6) }
    }
    case 'miesiac':
      return { od: dzien(r, m, 1), do: dzien(r, m + 1, 0) }
    case 'pop_miesiac':
      return { od: dzien(r, m - 1, 1), do: dzien(r, m, 0) }
    case 'rok':
      return { od: dzien(r, 0, 1), do: dzien(r, m, d) }
  }
}

export function rozwinOkres(o: Okres, teraz: Date = new Date()): { od: string; do: string; gotowy: GotowyOkres | null } {
  if ('gotowy' in o) return { ...zakresOkresu(o.gotowy, teraz), gotowy: o.gotowy }
  return { od: o.od, do: o.do, gotowy: null }
}
